import { render, staticRenderFns } from "./Formulary.vue?vue&type=template&id=4d8fc99e"
import script from "./Formulary.vue?vue&type=script&lang=js"
export * from "./Formulary.vue?vue&type=script&lang=js"
import style0 from "./Formulary.vue?vue&type=style&index=0&id=4d8fc99e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports